(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BUNDLE-bANNER"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-scroll-to-bundle]');
  if (!button) return;

  const currentSection = button.closest('.bundle-hero');
  let bundleSection = currentSection?.nextElementSibling;

  while (bundleSection && !bundleSection.querySelector?.('.pa4') && !bundleSection.matches?.('.pa4')) {
    bundleSection = bundleSection.nextElementSibling;
  }

  const target =
    bundleSection?.matches?.('.pa4')
      ? bundleSection
      : bundleSection?.querySelector?.('.pa4') || document.querySelector('.pa4');

  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Bundle-builder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pa4').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const selections = [null, null, null, null];
    const slots = Array.from(root.querySelectorAll('[data-slot]'));
    const progressCount = root.querySelector('[data-progress-count]');
    const bundleButton = root.querySelector('[data-add-bundle]');
    const bundleButtonLabel = bundleButton ? bundleButton.textContent.trim() : 'ADD BUNDLE TO CART';
    const errorBox = root.querySelector('[data-error]');
    const grid = root.querySelector('[data-grid]');
    const search = root.querySelector('[data-search]');
    const sort = root.querySelector('[data-sort]');
    const empty = root.querySelector('[data-empty]');
    const loading = root.querySelector('[data-products-loading]');
    const sectionId = root.dataset.sectionId;

    let cards = Array.from(root.querySelectorAll('[data-product-card]'));
    let activeFilter = 'all';
    let isLoadingProducts = false;

    const escapeHtml = (value) => {
      const div = document.createElement('div');
      div.textContent = value || '';
      return div.innerHTML;
    };

    const addedButtonHtml = `
      <span class="pa4__add-check" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
          <path d="M7.5 12.2L10.5 15.2L16.8 8.9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span>Added</span>
    `;

    const defaultButtonHtml = `
      <span class="pa4__add-label">Add</span>
      <span class="pa4__add-plus">+</span>
    `;

    const refreshCards = () => {
      cards = Array.from(root.querySelectorAll('[data-product-card]'));
    };

    const scrollToProducts = () => {
      const target = grid || root.querySelector('.pa4__toolbar');
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const render = () => {
      const count = selections.filter(Boolean).length;

      if (progressCount) progressCount.textContent = count;

      if (bundleButton) {
        bundleButton.disabled = count !== 4 || !bundleButton.dataset.parentVariantId;
      }

      slots.forEach((slot, index) => {
        const item = selections[index];
        const content = slot.querySelector('.pa4__slot-content');
        const remove = slot.querySelector('[data-remove-slot]');

        if (!content || !remove) return;

        if (!item) {
          content.innerHTML = '<button type="button" class="pa4__plus" data-scroll-products aria-label="Choose a product">+</button>';
          remove.hidden = true;
          return;
        }

        content.innerHTML = `
          <div class="pa4__slot-item">
            ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.productTitle)}">` : ''}
          </div>
        `;

        remove.hidden = false;
      });
    };

    const applyFilters = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let visible = 0;

      cards.forEach((card) => {
        const categoryMatch =
          activeFilter === 'all' ||
          card.dataset.category === activeFilter;

        const searchMatch =
          !query ||
          (card.dataset.title || '').includes(query);

        const show = categoryMatch && searchMatch;

        card.hidden = !show;

        if (show) visible += 1;
      });

      if (empty) {
        empty.hidden = visible !== 0 || isLoadingProducts;
      }
    };

    const applySort = () => {
      if (!grid || !sort) return;

      const mode = sort.value;
      const sorted = [...cards];

      sorted.sort((a, b) => {
        if (mode === 'az') {
          return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        }

        if (mode === 'za') {
          return (b.dataset.title || '').localeCompare(a.dataset.title || '');
        }

        if (mode === 'low') {
          return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
        }

        if (mode === 'high') {
          return Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
        }

        return 0;
      });

      sorted.forEach((card) => grid.appendChild(card));
      applyFilters();
    };

    const addProductToSelection = (button) => {
      if (!button || button.disabled) return;

      const emptyIndex = selections.findIndex((item) => item === null);

      if (emptyIndex === -1) return;
      if (button.classList.contains('is-added')) return;

      const card = button.closest('[data-product-card]');
      if (!card) return;

      const variantControl = card.querySelector('[data-variant-select]');
      if (!variantControl) return;

      const selectedOption =
        variantControl.tagName === 'SELECT'
          ? variantControl.options[variantControl.selectedIndex]
          : variantControl;

      if (
        !selectedOption ||
        selectedOption.dataset.available !== 'true'
      ) {
        return;
      }

      selections[emptyIndex] = {
        variantId: selectedOption.value,
        productTitle: button.dataset.productTitle,
        variantTitle: selectedOption.dataset.variantTitle || '',
        image: button.dataset.image || '',
        button
      };

      button.classList.add('is-added');
      button.innerHTML = addedButtonHtml;

      render();
    };

    /*
     * Load every remaining collection page automatically.
     * Shopify renders up to 250 products in each Liquid paginate request,
     * so additional pages are requested through the Section Rendering API
     * and appended to this same grid.
     */
    const loadAllProducts = async () => {
      if (!grid || !sectionId || isLoadingProducts) return;

      let nextLink = root.querySelector('[data-next-page]');

      if (!nextLink) return;

      isLoadingProducts = true;

      if (loading) loading.hidden = false;
      if (empty) empty.hidden = true;

      try {
        let safety = 0;

        while (nextLink && safety < 1000) {
          safety += 1;

          const requestUrl = new URL(
            nextLink.getAttribute('href'),
            window.location.origin
          );

          requestUrl.searchParams.set('section_id', sectionId);

          const response = await fetch(requestUrl.toString(), {
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (!response.ok) {
            throw new Error(`Unable to load products page ${safety + 1}.`);
          }

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const incomingRoot = doc.querySelector('.pa4');
          const incomingGrid = incomingRoot?.querySelector('[data-grid]');

          if (!incomingGrid) {
            nextLink = null;
            break;
          }

          const incomingCards = Array.from(
            incomingGrid.querySelectorAll('[data-product-card]')
          );

          incomingCards.forEach((card) => {
            grid.appendChild(card);
          });

          refreshCards();

          const incomingNext = incomingRoot.querySelector('[data-next-page]');

          if (incomingNext) {
            const currentNext = root.querySelector('[data-next-page]');

            if (currentNext) {
              currentNext.setAttribute(
                'href',
                incomingNext.getAttribute('href')
              );

              nextLink = currentNext;
            } else {
              nextLink = incomingNext;
            }
          } else {
            const currentNext = root.querySelector('[data-next-page]');

            if (currentNext) currentNext.remove();

            nextLink = null;
          }

          /*
           * Keep current customer filters/sorting active
           * while new products arrive.
           */
          if (sort?.value && sort.value !== 'default') {
            applySort();
          } else {
            applyFilters();
          }
        }
      } catch (error) {
        console.error('[Pick Any 4] Product auto-load error:', error);
      } finally {
        isLoadingProducts = false;

        if (loading) loading.hidden = true;

        refreshCards();

        if (sort?.value && sort.value !== 'default') {
          applySort();
        } else {
          applyFilters();
        }
      }
    };

    root.addEventListener('click', (event) => {
      const scrollButton = event.target.closest('[data-scroll-products]');

      if (scrollButton) {
        event.preventDefault();
        scrollToProducts();
        return;
      }

      const addButton = event.target.closest('[data-add-item]');

      if (addButton && root.contains(addButton)) {
        event.preventDefault();
        addProductToSelection(addButton);
      }
    });

    root.querySelectorAll('[data-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.filter;

        root.querySelectorAll('[data-filter]').forEach((b) => {
          b.classList.remove('is-active');
        });

        button.classList.add('is-active');
        applyFilters();
      });
    });

    search?.addEventListener('input', applyFilters);

    sort?.addEventListener('change', applySort);

    root.querySelectorAll('[data-remove-slot]').forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.removeSlot) - 1;
        const removedItem = selections[index];

        if (removedItem?.button) {
          removedItem.button.classList.remove('is-added');
          removedItem.button.innerHTML = defaultButtonHtml;
        }

        selections[index] = null;
        render();
      });
    });

    bundleButton?.addEventListener('click', async () => {
      if (selections.some((item) => !item)) return;

      const parentVariantId = Number(
        bundleButton.dataset.parentVariantId
      );

      if (!parentVariantId) {
        if (errorBox) {
          errorBox.textContent =
            'Please select the parent bundle product in the Theme Editor.';
          errorBox.hidden = false;
        }

        return;
      }

      bundleButton.disabled = true;
      bundleButton.textContent = 'ADDING…';

      if (errorBox) errorBox.hidden = true;

      const bundleId =
        `bundle-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

      const properties = {
        _bundle_id: bundleId
      };

      selections.forEach((item, index) => {
        const visibleName =
          item.variantTitle &&
          item.variantTitle !== 'Default Title'
            ? `${item.productTitle} — ${item.variantTitle}`
            : item.productTitle;

        properties[`Selection ${index + 1}`] = visibleName;
        properties[`_selection_${index + 1}_variant_id`] =
          item.variantId;
      });

      try {
        const rootPath = window.Shopify?.routes?.root || '/';

        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: parentVariantId,
                quantity: 1,
                properties
              }
            ]
          })
        });

        if (!response.ok) {
          const body = await response
            .json()
            .catch(() => ({}));

          throw new Error(
            body.description ||
            body.message ||
            'Unable to add bundle to cart.'
          );
        }

        const addedData = await response
          .json()
          .catch(() => null);

        /*
         * Impulse theme cart hooks.
         */
        document.dispatchEvent(
          new CustomEvent('cart:build')
        );

        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: {
              product: addedData
            }
          })
        );

        /*
         * Open Impulse cart drawer.
         */
        window.setTimeout(() => {
          const drawerTrigger =
            document.querySelector('.js-drawer-open-cart') ||
            document.querySelector('[aria-controls="CartDrawer"]') ||
            document.querySelector('[data-cart-drawer-trigger]');

          if (drawerTrigger) {
            drawerTrigger.click();
          } else {
            window.location.href = `${rootPath}cart`;
          }
        }, 250);
      } catch (error) {
        if (errorBox) {
          errorBox.textContent =
            error.message ||
            'Unable to add bundle to cart.';

          errorBox.hidden = false;
        }

        bundleButton.disabled = false;
        bundleButton.textContent = bundleButtonLabel;
      }
    });

    applyFilters();
    render();

    /*
     * Start fetching every remaining page immediately.
     * The grid progressively fills until the entire
     * selected collection has been loaded.
     */
    loadAllProducts();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
